export const Button = {
  button: {
    variants: {
      variant: {
        outline: {
          colorPalette: "white",
          border: "1px solid",
          borderColor: "colorPalette",
          color: "colorPalette",
          fontSize: "md",
          fontWeight: "semibold",
          overflow: "hidden",
          py: 6,
          pos: "relative",
          rounded: "lg",
          transition: "0.3s background-color, 0.3s color",
          width: { base: "full", lg: "22rem" },
          zIndex: 2,
          _hover: {
            bg: "colorPalette",
            borderColor: "colorPalette",
            color: "colorPalette.contrast",
          },
        },
        surface: {
          bgColor: "rgba(255, 255, 255, 0.15)",
          color: "white",
          pointerEvents: { base: "auto", lg: "none" },
          shadow: "0 0 0 1px white",
          textShadow: "1px 1px 1px rgba(0, 0, 0, 0.3)",
          userSelect: "none",
          h: { base: "3rem", lg: "2.5rem" },
          w: { base: "3rem", lg: "2.5rem" },
          "&:active, &.active": {
            bgColor: "rgba(255, 255, 255, 0.5)",
          },
          _hover: {
            bgColor: {
              lg: "rgba(255, 255, 255, 0.5)",
            },
          },
          "&:hover:not(&:active)": {
            bgColor: "rgba(255, 255, 255, 0.15)",
          },
        },
        ghost: {
          color: "white",
          _hover: {
            bg: "white",
            color: "black",
          },
          _expanded: {
            bgColor: "transparent",
            color: "white",
          },
        },
        subtle: {
          bg: "violet.600/80",
          border: "1px solid white",
          color: "white",
          fontSize: "md",
          fontWeight: "semibold",
          overflow: "hidden",
          py: 6,
          pos: "relative",
          rounded: "lg",
          transition: "0.3s background-color, 0.3s color",
          width: { base: "full", lg: "22rem" },
          zIndex: 2,
          _hover: {
            bg: "white",
            color: "violet.600",
          },
        },
        control: {
          bg: "black",
          color: "white",
          _hover: {
            bg: "white",
            color: "black",
          },
        },
      },
    },
  },
};
